import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@app/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { IUser } from '@app/core/interfaces/user/IUser';
import { UserService } from '@app/core/services/UserService';
import { IInvoice } from '@app/core/interfaces/IInvoice';
import { InvoiceService } from '@app/core/services/InvoiceService';
import { IEmployerTax } from '@app/core/interfaces/IEmployerTax';
import { LocalStorageService } from '@app/core/local-storage/local-storage.service';
import { MunicipalityService } from '@app/core/services/municipalityService';
import { MessagesDialogComponent } from '../../shared/messages/messages-dialog-component';
import { IGlobalMessagePublic } from '@app/core/interfaces/IGlobalMessage';
import { GlobalMessageService } from '@app/core/services/GlobalMessageService';
import { environment as env } from '@env/environment';
import { OrganizationService } from '@app/core/services/OrganizationService';
import { AuthenticationService } from '@app/core/services/AuthenticationService';
import { FeeService, ICalculatorSettings } from '@app/core/services/FeeService';
import { ITransactionLog } from '@app/core/interfaces/invoice/ITransactionLog';
import { firstValueFrom } from 'rxjs';
import { IFile } from '@app/core/interfaces/IFile';
import { FileService } from '@app/core/services/FileService';

@Component({
  standalone: false,
  selector: 'anms-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})

export class AboutComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  releaseButler = 'assets/release-butler.png';
  displayedColumns = ['icon', 'customer', 'paymentdue', 'money'];
  displayedColumnsCompany = ['invoicenumbercomp', 'amountcomp', 'paymentduecomp', 'invoicestatuscomp'];
  public isLoading: boolean = true;
  public user: IUser;
  public employertax: IEmployerTax;
  public municipalitytax: any;
  public invoice: IInvoice;
  public globalmessages: IGlobalMessagePublic[] = [];
  public isAdmin: boolean = false;
  @ViewChild(MatTable, { static: true }) table: MatTable<any>;
  invoiceData: Array<any> = [];
  statuses = [];
  selectedFilterStatus: any = { Id: 0, Name: 'Alla fakturor' };
  filter: string;
  dataSource: MatTableDataSource<IInvoice> = new MatTableDataSource<IInvoice>([]);
  isInvoiceLoading: boolean = false;
  invoiceSkeletonRows = [1, 2, 3, 4, 5];
  prelPaymentDue: Date;
  DueDate: number;
  municipalities: any;
  public appId: number = env.appId;
  isCompanyAdmin: boolean = false;
  organization: any;
  private invoiceLoadRetryCount = 0;
  private readonly maxInvoiceLoadRetries = 5;
  private readonly invoiceLoadRetryDelayMs = 1000;
  private calculatorSettingsPromise: Promise<void> | null = null;
  private lastInvoiceRequest: {
    statuses: Array<number> | null;
    pageIndex: number;
    pageSize: number;
    filter: string;
  };


  // Calculator
  invoiceFee: number = 29;
  samFeeFactor: number = 0;
  samFeeExpress: number = 0;
  samFeeSlide: boolean = false;
  samFeeNew: number;
  totalInvoiceAmount: number;
  partialTotalAmount: number;
  grossSalary: number;
  netSalary: number;
  employerTax: 0.3142;
  municipalityTax: number;
  displayTax: number;
  FeePaidByReciever: any;
  tempEmployerTax: number = 0.3; // Check if in DataBase
  arbetsgivarAvgift: number;
  myTax: number;
  noVat: number;
  withVat: number;
  vatStandard: number = 1.25; // Check if in DataBase
  vatMedium: number = 1.12; // Check if in DataBase
  vatLow: number = 1.06; // Check if in DataBase
  vat: number;
  withVatMedium: number;
  noVatMedium: number;
  noVatLow: number;
  withVatLow: number;
  totalInvoiceAmountR: number;
  MyNetSalaryR: number;
  MyGrossSalaryR: number;
  PartialTotalAmountR: number;
  samFeeNewR: number;
  netSalaryExpress: number;
  totalInvoiceAmountExpress: number;
  isCompanyUser: boolean = false;
  municipalityTaxMessage: string;

  constructor(
    private invoiceService: InvoiceService,
    private localStorageService: LocalStorageService,
    private userService: UserService,
    private municipalityService: MunicipalityService,
    private globalmessageService: GlobalMessageService,
    private router: Router,
    private organizationService: OrganizationService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private feeService: FeeService,
    private fileService: FileService,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {

    void this.ensureCalculatorSettingsLoaded();
    this.loadUser();


    if (this.appId == 1) {
      this.loadMunicipalities();
    }

  }

  loadUser() {

    if (this.authenticationService.userData.User == undefined) {
      alert('Användaren kunde inte hittas!');
    }

    this.user = this.authenticationService.userData.User;
    this.setCalculatorTaxesFromUser();
    this.isAdmin = this.authenticationService.userHasRole("admin");
    this.isCompanyAdmin = this.authenticationService.userHasRole('companyadmin');

    this.isCompanyUser = this.appId == 2
      ? this.isCompanyAdmin
      : this.user.IsCompany || this.isCompanyAdmin;

    if (this.appId == 2) {
      this.organization = this.authenticationService.getCurrentUserOrganization();
    }

    this.isLoading = false;

    // Default selectted item from storage
    var defaultItem = this.localStorageService.getItem("filterStatusDefault");

    if (defaultItem && this.isAdmin && this.appId == 1) {
      var item = JSON.parse(defaultItem);
      this.selectedFilterStatus = { Id: item.Id, Name: item.Name };

      this.getInvoices([item.Id], 0, 5, this.filter);

    }
    else {
      this.getInvoices(null, 0, 5, this.filter);
    }

    if (this.appId == 1) {
      this.getUserEmployerTax();
      this.getUserMunicipalityTax();
      //console.log(this.user);
    }

    //this.userService.getCurrentUser()
    //  .subscribe(value => this.userLoaded(value),
    //    error => console.log(error)
    //  );
  }

  async userLoaded(user: IUser) {

    this.user = user;
    this.setCalculatorTaxesFromUser();
    this.isAdmin = await this.userService.userHasRole("admin");
    this.isCompanyAdmin = await this.userService.userHasRole('companyadmin');

    this.isCompanyUser = this.appId == 2
      ? this.isCompanyAdmin
      : this.user.IsCompany || this.isCompanyAdmin;

    if (this.appId == 2) {
      this.organization = this.authenticationService.getCurrentUserOrganization();
    }

    this.isLoading = false;

    // Default selectted item from storage
    var defaultItem = this.localStorageService.getItem("filterStatusDefault");

    if (defaultItem && this.isAdmin && this.appId == 1) {
      var item = JSON.parse(defaultItem);
      this.selectedFilterStatus = { Id: item.Id, Name: item.Name };

      this.getInvoices([item.Id], 0, 5, this.filter);

    }
    else {
      this.getInvoices(null, 0, 5, this.filter);
    }

    if (this.appId == 1) {
      this.getUserEmployerTax();
      this.getUserMunicipalityTax();
      //console.log(this.user);
    }
  }

  getUserEmployerTax() {

    this.userService.getUserEmployerTax(this.user.Id)
      .subscribe(value => this.employerTaxLoaded(value),
        error => console.log(error)
      );
  }

  employerTaxLoaded(userEmployerTax: any) {
    this.employertax = userEmployerTax;
    this.recalculateSalary();
  }

  private setCalculatorTaxesFromUser(): void {
    this.employertax = this.user?.EmployerTax;
    this.municipalitytax = this.user?.Municipality?.Tax;
  }

  openInvoiceDocument(file: IFile, event?: Event) {
    event?.preventDefault();
    this.fileService.openFile(file);
  }

  getUserMunicipalityTax() {
    var today = new Date();
    this.userService.getUserMunicipalityTax(today, this.user.Id)
      .subscribe(value => this.municipalityTaxLoaded(value),
        error => console.log(error)
      );
  }

  municipalityTaxLoaded(userMunicipalityTax: any) {

    this.municipalitytax = userMunicipalityTax;

    const municipalityTaxPercent = (this.municipalitytax * 100).toLocaleString('sv-SE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    if (this.user.Municipality == null) {
      debugger
    }

    const municipalityTaxMessage = this.municipalitytax != this.user.Municipality.Tax
      ? "Din preliminära skatt beräknas med en justerad skattesats på " + municipalityTaxPercent + " % på grund av skattejustering eller jämkning."
      : "Din preliminära skatt beräknas med skattesatsen " + municipalityTaxPercent + " %.";

    window.setTimeout(() => this.municipalityTaxMessage = municipalityTaxMessage);

    this.recalculateSalary();
  }

	  getInvoices(statuses: Array<number> = null, pageIndex: number, pageSize: number, filter: string, showSkeleton: boolean = true) {

    if (showSkeleton) {
      this.isInvoiceLoading = true;
    }

    this.lastInvoiceRequest = { statuses, pageIndex, pageSize, filter };

    // All invoices selected
    if (statuses != null && statuses.length == 1 && statuses[0] == 0) {
      statuses = null;

    }

    //if (this.isAdmin == true) {
    //  this.invoiceService.getInvoices(statuses, pageIndex,pageSize, filter)
    //    .subscribe(value => this.onInvociesRetrieved(value),
    //      error => console.log(error)
    //    )
    //}

    if (this.appId == 1 || this.isAdmin) {
      this.invoiceService.getInvoicesWithUpcomingPayouts(statuses, pageIndex, pageSize, filter)
        .subscribe(value => this.onInvociesRetrieved(value),
          error => this.onInvoicesLoadFailed(error)
        );
    }

	    if (this.appId == 2) {
      if (!this.hasConnectedOrganization()) {
        this.invoiceData = [];
        this.dataSource = new MatTableDataSource(this.invoiceData);
        this.finishInvoiceLoading();
        return;
      }

	      this.invoiceService.getInvoicesByOrganization(this.organization.Id, statuses, pageIndex, pageSize, filter)
	        .subscribe(value => this.onInvociesRetrieved(value),
	          error => this.onInvoicesLoadFailed(error)
	        );
	    }
	  }

  private hasConnectedOrganization(): boolean {
    if (!this.organization) {
      return false;
    }

    const organizationId = Number(this.organization.Id || 0);
    const companyId = Number(this.organization.Company?.Id || 0);
    const companyName = typeof this.organization.Company?.Name === 'string' ? this.organization.Company.Name.trim() : '';
    const companyOrgNumber = typeof this.organization.Company?.OrgNumber === 'string' ? this.organization.Company.OrgNumber.trim() : '';

    return organizationId > 0 && companyId > 0 && companyName.length > 0 && companyOrgNumber.length > 0;
  }

	  onInvociesRetrieved(response: any) {
    const invoices = response?.Invoices ?? [];

    this.setInvoiceData(invoices);

    if (this.shouldRetryUpcomingPayoutLoad(invoices)) {
      this.invoiceLoadRetryCount++;
      window.setTimeout(() => {
        this.getInvoices(
          this.lastInvoiceRequest?.statuses ?? null,
          this.lastInvoiceRequest?.pageIndex ?? 0,
          this.lastInvoiceRequest?.pageSize ?? 5,
          this.lastInvoiceRequest?.filter,
          false
        );
      }, this.invoiceLoadRetryDelayMs);
      return;
    }

    this.invoiceLoadRetryCount = 0;

  }

  private setInvoiceData(invoices: any[]) {
    for (var i = 0; i < invoices.length; i++) {
      if (invoices[i].Status != undefined)
        invoices[i].Status.Id = invoices[i].Status.Id.toString();
    }

    this.invoiceData = invoices;
    this.dataSource = new MatTableDataSource(this.invoiceData);

    this.finishInvoiceLoading();
  }

  private onInvoicesLoadFailed(error: any) {
    console.log(error);
    this.invoiceData = [];
    this.dataSource = new MatTableDataSource(this.invoiceData);
    this.finishInvoiceLoading();
  }

  private finishInvoiceLoading(): void {
    window.setTimeout(() => {
      this.isInvoiceLoading = false;
      this.isLoading = false;
      this.changeDetectorRef.detectChanges();
    });
  }

  getUpcomingPayoutLog(invoice: IInvoice): ITransactionLog | null {
    if (!invoice?.TransactionLogs?.length) {
      return null;
    }

    return invoice.TransactionLogs.find(log => log?.IsPayoutTransLog) ?? invoice.TransactionLogs[1] ?? null;
  }

  getUpcomingPayoutAmount(invoice: IInvoice): number | null {
    const totalPayout = this.getUpcomingPayoutLog(invoice)?.TotalPayout;
    return typeof totalPayout === 'number' && totalPayout > 0 ? totalPayout : null;
  }

  private shouldRetryUpcomingPayoutLoad(invoices: IInvoice[]): boolean {
    return this.appId === 1
      && invoices.length > 0
      && invoices.some(invoice => this.getUpcomingPayoutAmount(invoice) == null)
      && this.invoiceLoadRetryCount < this.maxInvoiceLoadRetries;
  }

  // salaryCalculator
  async myCalculator(): Promise<number> {
    await this.ensureCalculatorSettingsLoaded();

    if (!Number.isFinite(this.totalInvoiceAmount)
      || !this.employertax
      || !Number.isFinite(this.employertax.Tax)
      || !Number.isFinite(this.municipalitytax)) {
      return 0;
    }

    this.samFeeNew = this.calculateServiceFeeAmount(this.totalInvoiceAmount, false);

    this.partialTotalAmount = Math.round(this.totalInvoiceAmount - this.samFeeNew);

    this.grossSalary = Math.round(this.partialTotalAmount / (1 + this.employertax.Tax));
    this.netSalary = Math.round(this.grossSalary - (this.grossSalary * this.municipalitytax));

    this.arbetsgivarAvgift = Math.round(this.partialTotalAmount - this.grossSalary);
    this.displayTax = Math.round(this.grossSalary * this.municipalitytax);

    return this.netSalary;
  }

  // expressSalaryCalculator
  async myExpressCalculator(finalAmountExpress: number) {
    await this.ensureCalculatorSettingsLoaded();

    if (!Number.isFinite(this.totalInvoiceAmountExpress)
      || !Number.isFinite(this.municipalitytax)) {
      return;
    }

    this.samFeeNew = this.calculateServiceFeeAmount(this.totalInvoiceAmountExpress, true);
    this.partialTotalAmount = Math.round(this.totalInvoiceAmountExpress - this.samFeeNew);

    this.grossSalary = Math.round(this.partialTotalAmount / (1 + this.tempEmployerTax));
    this.netSalaryExpress = Math.round(this.grossSalary - (this.grossSalary * this.municipalitytax));

    this.arbetsgivarAvgift = Math.round(this.partialTotalAmount - this.grossSalary);
    this.displayTax = Math.round(this.grossSalary * this.municipalitytax);

    finalAmountExpress = this.netSalaryExpress;
  }

  calculateServiceFeeAmount(totalInvoiceAmount: number, isExpress: boolean): number {
    if (!totalInvoiceAmount) {
      return 0;
    }

    const serviceFeeFactor = isExpress ? this.samFeeExpress : this.samFeeFactor;
    return Math.sign(totalInvoiceAmount) * Math.round(Math.abs(totalInvoiceAmount * serviceFeeFactor));
  }

  async loadCalculatorSettings(): Promise<void> {
    const settings = await firstValueFrom(this.feeService.getCalculatorSettings());

    if (!settings) {
      return;
    }

    this.applyCalculatorSettings(settings);
  }

  private ensureCalculatorSettingsLoaded(): Promise<void> {
    if (!this.calculatorSettingsPromise) {
      this.calculatorSettingsPromise = this.loadCalculatorSettings();
    }

    return this.calculatorSettingsPromise;
  }

  private recalculateSalary(): void {
    if (Number.isFinite(this.totalInvoiceAmount)) {
      void this.myCalculator();
    }

    if (Number.isFinite(this.totalInvoiceAmountExpress)) {
      void this.myExpressCalculator(this.totalInvoiceAmountExpress);
    }
  }

  applyCalculatorSettings(settings: ICalculatorSettings) {
    this.samFeeFactor = settings.ServiceFee;
    this.samFeeExpress = settings.GlobalExpressServiceFee;
  }

  roundToTwoDecimals(value: number): number {
    return Math.round(value * 100) / 100;
  }

  // vatCalcStandard 25%
  myVatCalc(totalAmount: number) {
    this.withVat = Math.round(this.noVat * this.vatStandard);
    totalAmount = this.withVat;
  }

  myNoVatCalc(totalNoVat: number) {
    this.noVat = Math.round(this.withVat / this.vatStandard);
    totalNoVat = this.noVat;
  }

  // vatCalcMedium 12%
  myVatCalcMedium(totalAmountMedium) {
    this.withVatMedium = Math.round(this.noVatMedium * this.vatMedium);
    totalAmountMedium = this.withVatMedium;
  }

  myNoVatCalcMedium(totalNoVatMedium: number) {
    this.noVatMedium = Math.round(this.withVatMedium / this.vatMedium);
    totalNoVatMedium = this.noVatMedium;
  }

  // vatCalcMedium 6%
  myVatCalcLow(totalAmountLow) {
    this.withVatLow = Math.round(this.noVatLow * this.vatLow);
    totalAmountLow = this.withVatLow;
  }

  myNoVatCalcLow(totalNoVatLow: number) {
    this.noVatLow = Math.round(this.withVatLow / this.vatLow);
    totalNoVatLow = this.noVatLow;
  }

  loadMunicipalities() {
    this.municipalityService.getMunicipalities()
      .subscribe(value => this.municipalitiesLoaded(value),
        error => console.log(error)
      );
  }

  loadGlobalMessages() {
    this.globalmessageService.getGlobalMessages(this.appId)
      .subscribe(value => this.globalMessagesLoaded(value),
        error => console.log(error)
      );
  }

  globalMessagesLoaded(globalmessages: IGlobalMessagePublic[]) {
    this.globalmessages = globalmessages
    console.log(this.globalmessages);
  }

  municipalitiesLoaded(municipalities: any) {
    this.municipalities = municipalities
  }

  municipalityChange(municipalityId: any) {

    for (var i = 0; i < this.municipalities.length; i++) {
      if (this.municipalities[i].Id == municipalityId) {
        this.user.Municipality.Tax = this.municipalities[i].Tax;
      }
    }

  }

  openDialog(data: IGlobalMessagePublic): void {
    const message = data;

    this.dialog.open(MessagesDialogComponent, {
      width: '720px',
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: 'calc(100vh - 32px)',
      data: { ...message },
    });

    if (message.IsRead) {
      return;
    }

    message.IsRead = true;
    this.globalmessageService.markAsRead(message.Id).subscribe(
      () => { },
      error => {
        message.IsRead = false;
        console.log(error);
      }
    );
  }

}



